module.exports = __webpack_public_path__ + "img/gb9115_27_c.prt.0507a242.jpg";